// Inactive organisation staff types are kept on the staff row, but they are not
// a current type: omit them from the picker and from the selected value.
export const visibleStaffTypeSelection = (staffTypes, staff) => {
	const types = Array.isArray(staffTypes) ? staffTypes : [];
	const options = types
		.filter((type) => type && type.active)
		.map((type) => type.staffType)
		.filter((name) => name);

	const assigned = staff?.organisationStaffTypeId
		? types.find(
				(type) =>
					type &&
					type.organisationStaffTypeId === staff.organisationStaffTypeId
		  )
		: null;

	return {
		options,
		selected: assigned?.active ? assigned.staffType : "",
	};
};
